import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/third_party_service_traces',
  component: Management,
  redirect: '/third_party_service_traces/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/third_party_service_traces/List'),
      meta: {
        auth: Auth.listThirdPartyServiceTraces
      }
    }
    // 详情
    // {
    //   path: ':id',
    //   component: () => import('@/views/third_party_service_traces/DetailLayout'),
    //   meta: {
    //     auth: Auth.showThirdPartyServiceTrace
    //   },
    //   children: [
    //     // 基本信息
    //     {
    //       path: 'detail',
    //       component: () => import('@/views/third_party_service_traces/details/Detail'),
    //       meta: {
    //         tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
    //         auth: Auth.showThirdPartyServiceTrace
    //       }
    //     }
    //   ]
    // }
  ]
}
